import { initNeosEventItemSelected } from "../../../Assets/Scripts/neosEvents.js";

export function slider() {
    if (document.querySelector(".slider")) {
        document.querySelectorAll(".slider").forEach((slider) => {
            const scrollContainer = slider.querySelector(".scroll--container")
            const itemContainer = slider.querySelector(".item--container")
            const cardList = slider.querySelector("ul.card--list");
            const cards = Array.from(cardList.querySelectorAll(".slider--card"));
            const buttonPrev = slider.querySelector("button.slider-navigation-prev");
            const buttonNext = slider.querySelector("button.slider-navigation-next");

            if (cards.length >= 2) {
                let currentIndex = 0;
                let lastClickTime = 0;
                let autoplayTimer;

                // Autoplay starten
                const startAutoplay = () => {
                    if (slider.hasAttribute("autoplay")) {
                        autoplayTimer = setInterval(() => {
                            if (currentIndex < cards.length - 1) {
                                updateCurrentCard(currentIndex + 1);
                            } else {
                                updateCurrentCard(0);
                            }
                        }, 5000);
                    }
                };

                // Autoplay stoppen
                const stopAutoplay = () => {
                    clearInterval(autoplayTimer);
                };

                // Benutzerinteraktionen überwachen und Autoplay-Timer zurücksetzen
                const resetAutoplay = () => {
                    stopAutoplay();
                    startAutoplay();
                };

                // Funktion, um den aktuellen Index basierend auf der linken Position der Karten zu aktualisieren
                const updateCurrentIndex = () => {
                    cards.forEach((card, index) => {
                        const containerDefaultPositionLeft = scrollContainer.getBoundingClientRect().left;
                        const cardRectWidth = card.getBoundingClientRect().width;
                        const cardRectLeft = card.getBoundingClientRect().left;
                        const cardDefaultDistanceLeft = parseInt(window.getComputedStyle(itemContainer).paddingLeft, 10);
                        const distance = cardDefaultDistanceLeft - cardRectLeft
                        const distanceFullWidth = containerDefaultPositionLeft - cardRectLeft
                        

                        if (!slider.hasAttribute('fullwidth') && distance >= cardRectWidth * -0.6 && distance <= cardRectWidth * 0.4) {
                            currentIndex = index
                        }

                        if (slider.hasAttribute('fullwidth') && distanceFullWidth >= cardRectWidth * -0.6 && distanceFullWidth <= cardRectWidth * 0.4) {
                            currentIndex = index
                        }
                    });
                };

                // Zur aktuellen Karte bewegen
                const updateCurrentCard = (newIndex) => {
                    currentIndex = newIndex;
                    const currendCardRect = cards[currentIndex].getBoundingClientRect();
                    const scrollContainerRect = scrollContainer.getBoundingClientRect();
                    const cardDefaultDistanceLeft = parseInt(window.getComputedStyle(itemContainer).paddingLeft, 10);
                    const offset = currendCardRect.left - scrollContainerRect.left - cardDefaultDistanceLeft;

                    scrollContainer.scrollTo({
                        left: scrollContainer.scrollLeft + offset,
                        behavior: 'smooth'
                    });

                    updateButtonState();
                };

                // Navigation-Button-Status aktualisieren
                const updateButtonState = () => {
                    setTimeout(() => {
                         // Deaktiviert, wenn ganz links
                        const scrollContainerStart = Math.round(scrollContainer.getBoundingClientRect().left);
                        const itemContainerStart = Math.round(itemContainer.getBoundingClientRect().left);
                        buttonPrev.disabled = scrollContainerStart == itemContainerStart;
                        
                        // Deaktiviert, wenn ganz rechts
                        const scrollContainerEnd = Math.round(scrollContainer.getBoundingClientRect().right);
                        const itemContainerEnd = Math.round(itemContainer.getBoundingClientRect().right);
                        buttonNext.disabled = scrollContainerEnd == itemContainerEnd;
                    }, 600);
                };

                // Vermeiden von Mehrfachklicks, bevor der Slider seinen neuen Zustand und Index erreicht
                function handleClick(threshold, callback) {
                    const currentTime = new Date().getTime();

                    // Prüfen, ob threshold (z.B. 600ms) seit dem letzten Klick vergangen sind
                    if (currentTime - lastClickTime < threshold) {
                        return; // Ignoriere den Klick, wenn er innerhalb des Zeitlimits liegt
                    }

                    lastClickTime = currentTime;
                    callback();
                }

                // Slider nach rechts navigieren
                buttonNext.addEventListener("click", () => {
                    resetAutoplay();

                    handleClick(600, () => {
                        if (currentIndex < cards.length - 1) {
                            updateCurrentCard(currentIndex + 1);
                        }
                    });
                });

                // Slider nach links navigieren
                buttonPrev.addEventListener("click", () => {
                    resetAutoplay();

                    handleClick(600, () => {
                        if (currentIndex > 0) {
                            updateCurrentCard(currentIndex - 1);
                        }
                    });
                });

                // Werte aktualisieren, wenn Slider gescrollt wird
                scrollContainer.addEventListener("scroll", () => {
                    updateButtonState();
                    updateCurrentIndex();
                    resetAutoplay();
                });

                // Werte aktualisieren, wenn Slider mit tab bewegt wird
                cards.forEach((card, index) => {
                    card.addEventListener('focusin', () => {
                        updateCurrentCard(index);
                        updateButtonState();
                        resetAutoplay();
                    });
                });

                // Drag-Funktionalität
                let isDragging = false;
                let mouseX;
                let startX;
                let scrollLeft;
                let currentScrollLeft;


                // CSS-ScrollSnap deaktiveren
                const disableScrollSnap = () => {
                    scrollContainer.style.scrollSnapType = "none";
                    document.body.style.userSelect = 'none';
                };

                // CSS-ScrollSnap aktivieren
                const enableScrollSnap = () => {
                    updateCurrentCard(currentIndex)
                    document.body.style.userSelect = '';

                    let lastScrollLeft = currentScrollLeft

                    scrollTimer = setTimeout(() => {
                        if (lastScrollLeft === currentScrollLeft) {
                            scrollContainer.style.scrollSnapType = "x mandatory";
                        }
                        // Aktualisiere den letzten scrollLeft-Wert
                        lastScrollLeft = currentScrollLeft
                    }, 600);

                };

                // Link-Weiterleitung deaktiveren
                const disableLinks = () => {
                    scrollContainer.querySelectorAll('a').forEach(link => {
                        link.style.pointerEvents = 'none';
                    });
                };
                
                // Link-Weiterleitung aktiveren
                const enableLinks = () => {
                    scrollContainer.querySelectorAll('a').forEach(link => {
                        link.style.pointerEvents = '';
                    });
                };

                scrollContainer.addEventListener('mousedown', (e) => {
                    isDragging = true;
                    disableScrollSnap();
                    mouseX = e.pageX
                    startX = mouseX - scrollContainer.offsetLeft;
                    scrollLeft = scrollContainer.scrollLeft;    
                    disableLinks()
                    stopAutoplay();
                });

                scrollContainer.addEventListener('mouseleave', () => {
                    if (isDragging) {
                        isDragging = false;
                        enableScrollSnap();
                        enableLinks()
                        resetAutoplay();
                    }
                });

                scrollContainer.addEventListener('mouseup', (e) => {
                    isDragging = false;
                    mouseXCurrent = e.pageX
                    const mouseWalk = mouseX - mouseXCurrent

                    // Entscheidung, ob Klick oder Drag anhand Mauszeigerposition zwischen mousedown und mouseup
                    if (mouseWalk <= 10 && mouseWalk >= -10) {
                        if (e.target.querySelector('a')) {
                            window.location.href = e.target.querySelector('a').href;
                        }
                    }
                    enableLinks()
                    enableScrollSnap();
                    resetAutoplay();
                });

                scrollContainer.addEventListener('mousemove', (e) => {
                    if (!isDragging) return;
                    e.preventDefault();
                    const x = e.pageX - scrollContainer.offsetLeft;
                    const walk = (x - startX) * 1.25;
                    scrollContainer.scrollLeft = scrollLeft - walk;
                    currentScrollLeft = scrollLeft - walk;

                    updateCurrentIndex()
                });

                // Observer, um Autoplay nur zu starten, wenn der Slider im Viewport ist
                if (slider.hasAttribute("autoplay")) {
                    new IntersectionObserver((entries, observer) => {
                        if (entries[0].isIntersecting) {
                            observer.disconnect();
                            resetAutoplay();
                        }
                    }).observe(slider);
                }
            }
            
            initNeosEventItemSelected(slider);
        });
    }
}

slider();
